module.exports = __webpack_public_path__ + "static/media/user-clock.8b8860ae.svg";